import { AuthContext } from '@repo-level/core-front';
import type { CMSGroupParams } from 'api/cms/base';
import { groupsExclude, groupsInclude } from 'helpers/cms';
import { allPass } from 'ramda';
import { useContext, useMemo } from 'react';

export const useMatchingSection = <T extends CMSGroupParams>(sections: T[]) => {
  const { user } = useContext(AuthContext);

  const section = useMemo(() => {
    const section = sections.find((section) =>
      allPass([groupsInclude(user), groupsExclude(user)])(section)
    );
    if (section) return section;
    return sections.find(
      ({ groupsExclude, groupsInclude }) => !(groupsExclude || groupsInclude)
    );
  }, [sections, user]);

  return section;
};
